import { __assign, __read, __rest } from "tslib";
/* eslint-disable dot-notation */
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
import { KeyMap } from "../_util/key-map";
import { TextArea } from "./TextArea";
import { InputPassword } from "./InputPassword";
export var Input = forwardRefWithStatics(function (props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = useDefaultValue(props, ""), children = _b.children, // never
    multiline = _b.multiline, placeholder = _b.placeholder, disabled = _b.disabled, readonly = _b.readonly, size = _b.size, type = _b.type, baseClassName = _b.baseClassName, className = _b.className, style = _b.style, value = _b.value, onChange = _b.onChange, showCount = _b.showCount, _c = _b.onCompositionStart, onCompositionStart = _c === void 0 ? noop : _c, _d = _b.onCompositionEnd, onCompositionEnd = _d === void 0 ? noop : _d, _e = _b.onKeyPress, onKeyPress = _e === void 0 ? noop : _e, _f = _b.onPressEnter, onPressEnter = _f === void 0 ? noop : _f, restProps = __rest(_b, ["children", "multiline", "placeholder", "disabled", "readonly", "size", "type", "baseClassName", "className", "style", "value", "onChange", "showCount", "onCompositionStart", "onCompositionEnd", "onKeyPress", "onPressEnter"]);
    var composingRef = useRef(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _g = __read(useState(""), 2), composingRefValue = _g[0], setComposingValue = _g[1];
    var basename = baseClassName || classPrefix + "-" + (multiline ? "textarea" : "input");
    var inputClassName = classNames((_a = {},
        _a[basename] = true,
        _a[className] = className,
        _a["size-" + (size === "full" ? size + "-width" : size)] = size,
        _a));
    var hasRows = multiline && restProps.rows;
    var inputProps = __assign({ placeholder: placeholder, className: inputClassName, readOnly: readonly, disabled: disabled, 
        // 受样式限制 rows 属性没有生效
        style: hasRows ? __assign({ height: "auto" }, (style || {})) : style, value: composingRef.current ? composingRefValue : value, onChange: function (event) {
            if (composingRef.current) {
                setComposingValue(event.target.value);
            }
            else {
                onChange(event.target.value, { event: event });
            }
        }, onCompositionStart: function (event) {
            composingRef.current = true;
            onCompositionStart(event);
        }, onCompositionEnd: function (event) {
            if (composingRef.current) {
                composingRef.current = false;
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue("");
            onCompositionEnd(event);
        }, onKeyPress: function (event) {
            if (event.key === KeyMap.Enter) {
                onPressEnter(event.currentTarget.value, event);
            }
            onKeyPress(event);
        } }, restProps);
    if (multiline) {
        var component = React.createElement("textarea", __assign({ ref: ref }, inputProps));
        if (showCount) {
            var max = inputProps.maxLength;
            var len = value ? String(value).length : 0;
            return (React.createElement("div", { className: classPrefix + "-textarea-group" },
                component,
                React.createElement("label", { className: classPrefix + "-textarea__label" }, max ? len + " / " + max : len)));
        }
        return component;
    }
    return React.createElement("input", __assign({ ref: ref, type: type }, inputProps));
}, {
    /**
     * TextArea 组件
     */
    TextArea: TextArea,
    /**
     * Password 组件
     */
    Password: InputPassword,
    /**
     * 在表单布局中，和 label 的默认对齐方式
     */
    defaultLabelAlign: "middle",
});
Input.displayName = "Input";
//# sourceMappingURL=Input.js.map